export default __webpack_public_path__ + "static/media/poultryPalaza.e5e60a53.png";